<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户账号" class='tiny'>
						<el-input clear style="width: 200px;" v-model="searchInfo.username" placeholder="请输入账号">
						</el-input>
					</el-form-item>
					<!-- <el-form-item label="资产名称" class='tiny'>
                        <el-select v-model="searchInfo.integralId" class="big" placeholder="请选择" clear>
                            <el-option v-for="item in integralList" :key="item.id" :value="item.id" :label="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
					<!-- <el-form-item label="资产名称" class='tiny'>
                        <el-input style="width: 200px;" v-model="searchInfo.tiname" placeholder="请输入资产名称"></el-input>
                    </el-form-item> -->
					<!-- <el-form-item label="变动类型" class='tiny'>
                        <el-col :span="8">
                            <el-select style="width: 200px;" v-model="searchInfo.type" class="big" placeholder="请选择"
                                clear>
                                <el-option v-for="item in typeList" :key="item.id" :value="item.id"
                                    :label="item.typeName"></el-option>
                            </el-select> 
                        </el-col>
                    </el-form-item> -->
					<!-- <el-form-item label="时间">
                        <div class="block">
                            <el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
                                :default-time="['00:00:00', '23:59:59']">
                            </el-date-picker>
                        </div>
                    </el-form-item> -->
					<!-- 
                    <el-form-item label="收支" class='tiny'>
                        <el-select v-model="searchInfo.changeType" placeholder="请选择">
                            <el-option key="0" label="支出" value="0"></el-option>
                            <el-option key="1" label="收入" value="1"></el-option>
                        </el-select>
                    </el-form-item> -->

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="editialogVisible()">新增用户
                            </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>

		<!-- <div style="margin: 20px;">
            <div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
                <div>
                    <span style="font-weight: bold;">统计</span><span style="font-size: 12px;">(资产名称必选)</span>：
                </div>
                <div style="margin-right: 30px;">
                    总金额: {{allData?allData:0 |intToFloatfour|cutZero}}
                </div>
                <div>
                    总支出: {{allData.bigDecimal1?allData.bigDecimal1:'0'}}
                </div>
            </div>
        </div> -->


		<el-table class="tables" :data="userRecordList.list" stripe style="width: 100%;" :header-cell-style="headClass"
		 v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<!-- <el-table-column prop="id" label="序号" sortable align="center">
            </el-table-column> -->
			<el-table-column prop="username" label="用户账号" align="center"  :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="tdValueTotal" label="TD历史总值" align="center" >
			</el-table-column>
			<el-table-column prop="tdValue" label="TD值" align="center" >
			</el-table-column>

			<el-table-column prop="fdValue" label="FD值" align="center" >
			</el-table-column>
			<el-table-column prop="flowPoolTotal" label="福利池总量" align="center">
			</el-table-column>
			<el-table-column prop="flowPool" label="福利池剩余" align="center">
			</el-table-column>
			<el-table-column prop="flowPoolLock" label="福利池锁仓" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="createTime" label="创建时间" align="center">
			</el-table-column>
			<!-- <el-table-column  label="操作"  fixed="right" align="center">
                　　　　<template slot-scope="scope">
                    　　　　　　<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
                    　　　　　　<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">拨币</el-button>
                    　　　　</template>
                　　</el-table-column> -->
		</el-table>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<el-pagination style="margin: 20px;" :page-sizes="[10,50, 100, 150, 200,300,400,500]" background :current-page="userRecordList.pageNum"
			 @current-change="pageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"
			 :total="userRecordList.total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				userRecordList: [], //用户列表
				dialogVisible: false,
				typeList: [],
				integralList: [],
				integralId: "", //积分id
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				allData: {}
			};
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}

		},
		methods: {
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserPoolList();
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserPoolList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserPoolList()
			},
			getUserPoolList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					username: this.searchInfo.username
				}
				this.$api.getUserPoolList(data).then((res) => {
					if (res.state == 'success') {
						this.userRecordList = res.data
						this.loading = false
					}
				})
				// this.$api.getUserRecordListSum(data).then((res) => {
				//     if (res.state == 'success') {
				//         this.allData = res.data
				//     }
				// })
			},
			getRecordTypeList() {
				let data = {}
				this.$api.getRecordTypeList(this.$encrypt(data)).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					// console.log('数据---',res )
					if (res.state == 'success') {
						this.typeList = res.data
					}
				})
			},
		},
		created() {
			this.getUserPoolList();
			// this.getRecordTypeList();
			// this.$api.getIntegralList().then((res) => {
			//     if (res.state == 'success') {
			//         this.integralList = res.data
			//     }
			// })
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
